import {API_URL, authHeaders, jsonHeaders} from "./index";

export async function apiGetReports() {
    const res = await fetch(`${API_URL}/reports`, {headers: authHeaders()});
    return res.json();
}

export async function apiCreateReport(type, target_id, reason) {
    const res = await fetch(`${API_URL}/reports`, {
        method: "POST",
        headers: jsonHeaders(),
        body: JSON.stringify({type, target_id, reason})
    });
    return res.json();
}

export async function apiDeleteReportContent(reportId) {
    const res = await fetch(`${API_URL}/reports/${reportId}/content`, {
        method: "DELETE",
        headers: authHeaders()
    });
    return res.json();
}
